// source: template-project@7007a338a apps/backoffice/src/app-shell/app-v3-nav.ts (APP_V3_NAV_SECTIONS, APP_V3_MORE_TOOLS_SECTION: labels and icons only)
import {
  ChartLine,
  ChevronsUpDown,
  Funnel,
  FolderKanban,
  Home,
  Map as MapIcon,
  Megaphone,
  Microscope,
  Store,
  Wand2,
  type LucideIcon,
} from 'lucide-react';

/**
 * How TP draws a menu entry:
 *   leaf   a link: text only while the sidebar is expanded (`NAV_LEADING_ICON_CLASS` hides its icon)
 *   hub    a link that drills into a panel of the sidebar: text and a right chevron (Advertising, Stores)
 *   group  a row that opens its sub-menu in place: category icon, label and a toggle chevron
 */
export type NavEntryKind = 'leaf' | 'hub' | 'group';

export interface NavEntry {
  label: string;
  icon: LucideIcon;
  kind: NavEntryKind;
}

/** The nine entries of TP's /app-v3 main menu, in order (one unlabelled section). */
export const NAV_ENTRIES: readonly NavEntry[] = [
  { label: 'Home', icon: Home, kind: 'leaf' },
  { label: 'Projects', icon: FolderKanban, kind: 'leaf' },
  { label: 'Performance', icon: ChartLine, kind: 'group' },
  { label: 'Research', icon: Microscope, kind: 'group' },
  { label: 'Advertising', icon: Megaphone, kind: 'hub' },
  { label: 'Creative Studio', icon: Wand2, kind: 'group' },
  { label: 'Funnels', icon: Funnel, kind: 'group' },
  { label: 'Plan', icon: MapIcon, kind: 'group' },
  { label: 'Stores', icon: Store, kind: 'hub' },
];

/** The row under the menu that opens the tools kept out of it (TP MoreToolsNav). */
export const MORE_TOOLS_ENTRY = { label: 'More Tools', icon: ChevronsUpDown } as const;

/** The one room the mock lists: the onboarding itself, pinned (TP `pinnedRooms`). */
export const ONBOARDING_ROOM_TITLE = 'Onboarding';
